import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { LoginCallback, Security } from '@okta/okta-react';
import PropTypes from 'prop-types';

import { oktaAuth, onAuthRequired } from '../common/auth';
import { IS_PRE_EXISTING_CART_CLEARED } from '../common/constants';
import ErrorBoundary from '../common/ErrorBoundary';
import LdsRing from '../common/LdsRing';
import { getAppConfig, restoreOriginalUri, setAnalyticsEvents, updateSessionStorage } from '../common/utilities';
import ErrorUserNotAssigned from './components/ErrorUserNotAssigned';
import LoginModal from './components/LoginModal';
import OktaSignInWidget from './components/OktaSignInWidget';
import RedirectSecured from './components/RedirectSecured';
import { PAGE_NAME } from './constant';

import '../../themes/default/apps/login/index.css';
import './styles/index.css';

const App = ({ config }) => {
  const {
    modalContent,
    widgetFooterContent,
    labels: { employeeSignIn },
    i18n
  } = config;

  const [isUserViaSSO, setIsUserViaSSO] = useState(false);
  const basename = getAppConfig('server').path;

  const LoaderCallback = () => (
    <div className="okta-signing-loader">
      <LdsRing />
    </div>
  );

  const redirectSSO = async () => {
    await oktaAuth.signInWithRedirect();
  };

  useEffect(() => {
    const query = window.location.search;
    const isFromSSO = query.includes('fromLogin=true');
    if (isFromSSO) {
      setIsUserViaSSO(true);
      redirectSSO();
    }
    setAnalyticsEvents();
    updateSessionStorage.setItem(IS_PRE_EXISTING_CART_CLEARED, false);
  }, []);

  return (
    <>
      <LoginModal content={modalContent.richText} />
      <Router forceRefresh basename={basename}>
        <ErrorBoundary componentTitle={PAGE_NAME}>
          <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri} onAuthRequired={onAuthRequired}>
            <RedirectSecured>
              <Routes>
                {isUserViaSSO ? (
                  <LoaderCallback />
                ) : (
                  <Route
                    exact
                    path="/login"
                    element={
                      <OktaSignInWidget labels={{ employeeSignIn, i18n }} widgetFooterContent={widgetFooterContent} />
                    }
                  />
                )}
                <Route
                  path="/login/implicit/callback"
                  element={
                    <LoginCallback
                      errorComponent={ErrorUserNotAssigned}
                      loadingElement={!isUserViaSSO && <LoaderCallback />}
                    />
                  }
                />
              </Routes>
            </RedirectSecured>
          </Security>
        </ErrorBoundary>
      </Router>
    </>
  );
};

App.propTypes = {
  config: PropTypes.instanceOf(Object).isRequired
};

export default App;
